"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BluetoothDeviceBondStates = void 0;
exports.BluetoothDeviceBondStates = {
    BOND_NONE: 10,
    BOND_BONDING: 11,
    BOND_BONDED: 12
};
